export const teamMembersIsClicked = () => {

    const app = window.smetioApp;
    const sideMenuToUse = "teamMembers";
    const apiEndPoint = app.apiEndPoint;
    const language = app.language;

    app.smetioAppUi.actionBar.showAll();
    app.smetioAppUi.actionBar.hide("listView");
    app.smetioAppUi.actionBar.hide("refresh");    
    app.smetioAppUi.actionBar.buttons.createNew.events["mousedown"] = async () => {

        const {confirmCreateTeamMember} = (await import(/* webpackPrefetch: true */ "./confirmCreateTeamMember"));
       
        return await confirmCreateTeamMember({
            apiEndPoint,
            language,
            title: "txt680",
            accountType: app.accountType,
            urlDestination: "create"
        });

    };

    app.smetioAppUi.actionBar.buttons.createNewFromFile.events["mousedown"] = async () => {

        const {createNewTeamMemberFromFile} = (await import(/* webpackPrefetch: true */ "./createNewTeamMemberFromFile.js"));
       
        return await createNewTeamMemberFromFile({
            apiEndPoint,
            language,
            title: "txt1756",
            accountType: app.accountType,
            urlDestination: "create"
        });

    }; 

    window.currentlyVisibleSideMenuItemName = sideMenuToUse;

    app.getTotalNumberOfAvailableData(sideMenuToUse);


};
